import React, { useState } from "react";
import styles from "./ZiplineTabs.module.scss";

import { Tabs, Tab } from "@blueprintjs/core";
import { camelize } from "../../helpers/StringManipulation";
import classnames from "classnames";

function ZiplineTabs({
  selectedTabId = null,
  onTabSelect = () => {},
  tabTitles,
  loading
}) {
  const [localSelectedTabId, localSetSelecteTabId] = useState(() =>
    camelize(selectedTabId || tabTitles[0])
  );

  const onTabChange = (newTabId) => {
    const setTag = onTabSelect || localSetSelecteTabId;
    setTag(newTabId);
  };

  return (
    tabTitles.length > 0 && (
      <Tabs
        className={styles.ziplineTabs}
        onChange={onTabChange}
        selectedTabId={loading ? null : selectedTabId || localSelectedTabId}
      >
        {tabTitles.map((tabTitle) => (
          <Tab
            key={tabTitle}
            id={camelize(tabTitle)}
            className={classnames(loading && "bp3-skeleton", styles.tab)}
            title={tabTitle}
          />
        ))}
      </Tabs>
    )
  );
}

export default ZiplineTabs;
